import { InjectionToken } from "@angular/core";

export const IToken_Service_Token = new InjectionToken<ITokenService>(
  "tokenService"
);


export interface ITokenService {
  setToken(newToken: string, tokenName?: string);
  getToken(tokenName?: string);
  clearToken();
}